import React from 'react';
import { StatefulPopover } from 'baseui/popover';
import { Filter } from 'baseui/src/icon';
import { PLACEMENT } from 'baseui/src/popover';
import FilterItem from './filter-item';
type PropsT = {
  setLabelMap: (labelMap: {
    [key: string]: boolean;
  }) => void;
  labelMap: {
    [key: string]: boolean;
  };
};
export const FilterContainer = ({
  setLabelMap,
  labelMap
}: PropsT) => {
  return <StatefulPopover placement={PLACEMENT.bottom} content={() => Object.keys(labelMap).map((annotationLabel, index) => <FilterItem key={index} title={annotationLabel} setLabelMap={setLabelMap} labelMap={labelMap} />)}>
      <Filter $size={22} />
    </StatefulPopover>;
};